module.exports = __webpack_public_path__ + "static/logo.d73696b0.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Cta/logo.svg
// module id = 799
// module chunks = 0